/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPointHistoryLocation
 */
export interface DataPointHistoryLocation {
    /**
     * 
     * @type {DataPointHistoryLocationTypeEnum}
     * @memberof DataPointHistoryLocation
     */
    type?: DataPointHistoryLocationTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataPointHistoryLocation
     */
    coordinates?: Array<number>;
}


/**
 * @export
 */
export const DataPointHistoryLocationTypeEnum = {
    Point: 'Point'
} as const;
export type DataPointHistoryLocationTypeEnum = typeof DataPointHistoryLocationTypeEnum[keyof typeof DataPointHistoryLocationTypeEnum];


/**
 * Check if a given object implements the DataPointHistoryLocation interface.
 */
export function instanceOfDataPointHistoryLocation(value: object): value is DataPointHistoryLocation {
    return true;
}

export function DataPointHistoryLocationFromJSON(json: any): DataPointHistoryLocation {
    return DataPointHistoryLocationFromJSONTyped(json, false);
}

export function DataPointHistoryLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointHistoryLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

export function DataPointHistoryLocationToJSON(json: any): DataPointHistoryLocation {
    return DataPointHistoryLocationToJSONTyped(json, false);
}

export function DataPointHistoryLocationToJSONTyped(value?: DataPointHistoryLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

